module.exports = __webpack_public_path__ + "static/media/nextmed-logo-sm-light.0f0a25ab.png";